import { useStateContext } from '../../modules/stateContext';

export function usePurpose() {
    const { purpose } = useStateContext();

    const isSubscription = purpose === 'subscription';

    return { isSubscription };
}
